import React, { Component } from "react";

import styled from "styled-components";

class Table extends Component {
  render() {
    const { colgroup, theadList, tbodyList } = this.props;

    return (
      <TableWrap>
        <TableHead className="table-comm" colgroup={colgroup}>
          {theadList.map((thead, idx) => (
            <div className="thead" key={idx}>
              {thead}
            </div>
          ))}
        </TableHead>
        <TableBody className="table-comm" colgroup={colgroup}>
          {tbodyList.map((tbody, idx) => (
            <div className="tbody" key={idx}>
              {tbody}
            </div>
          ))}
        </TableBody>
      </TableWrap>
    );
  }
}
const TableWrap = styled.div`
  margin-bottom: 10px;
  .table-comm {
    display: grid;
    text-align: center;
  }
`;
const TableHead = styled.div`
  grid-template-columns: ${({ colgroup }) => colgroup || "2fr 1fr"};
  border-top: 1px solid #dce0e3;
  border-bottom: 1px solid #dce0e3;
  background: #f1f3f5;
  .thead {
    color: #484848;
    font-size: 14px;
  }
`;
const TableBody = styled.div`
  grid-template-columns: ${({ colgroup }) => colgroup || "2fr 1fr"};
  border-bottom: 1px solid #dce0e3;
  .tbody {
    color: #8a8a8a;
    font-size: 14px;
  }
`;
export default Table;
